export const QueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message'
};

export const LoginActions = {
  Login: 'login',
  LoginCallback: 'login-callback',
  SilentRediectUri: 'silent-renew'
};

export const LogoutActions = {
  Logout: 'logout',
  LoggedOut: 'logged-out'
};

const prefix = '/authentication';

export const ApplicationPaths = {
  AuthorizationPrefix: `${prefix}`,
  Login: `${prefix}/${LoginActions.Login}`,
  LoginCallback: `${prefix}/${LoginActions.LoginCallback}`,
  Logout: `${prefix}/${LogoutActions.Logout}`,
  LoggedOut: `${prefix}/${LogoutActions.LoggedOut}`,
  LogoutCallback: `${prefix}/${LogoutActions.LoggedOut}`,
  SilentRediectUri: `${prefix}/${LoginActions.SilentRediectUri}`
};

export const CookieNames = {
  ApiSecurity: 'SumTotal_ApiSecurity'
};

export const BrokerParams = ['domain', 'lang', 'username', 'password'];
